import React, {useContext, useState, useEffect} from 'react';
import {handleDownloadEdapEvent, handleOnloadEdapEvent} from '../utils/triggerEdapEvent';
import {MOBILE__16} from '@homeaway/svg-defs';
import {TrackingContext} from '@homeaway/react-event-tracking';
import {SVGIcon} from '@homeaway/react-svg';
import './AppDownloadDesktopButton.less';
import * as BannerDefaults from '../banner-defaults';
import * as BannerHelpers from '../utils/bannerHelpers';

export const AppDownloadDesktopButton = ({buttonLabel, travelerApp, siteLocale}) => {
    buttonLabel = BannerHelpers.getButtonLabel(buttonLabel);
    const brandName = BannerHelpers.getBrandName(travelerApp);
    const [path, setPath] = typeof window !== 'undefined' ? useState(window.location.host) : '';
    const context = useContext(TrackingContext);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setPath(window.location.origin);
        }
    }, [path]);

    useEffect(() => {
        handleOnloadEdapEvent(context, BannerDefaults.BUTTON);
    }, []);

    function createLink() {
        if (brandName === BannerDefaults.VRBO && siteLocale !== 'en-us') {
            return `${path}/${siteLocale}/mobile?desktopHeader=true`;
        }
        return `${path}/mobile?desktopHeader=true`;
    }
    const link = createLink();

    function handleAppDownloadButtonClick() {
        handleDownloadEdapEvent(context, BannerDefaults.BUTTON);
    }
    return (<div className="app-download-desktop-button__container">
        <a className="btn btn-default app-download-desktop-button"
            href={link} target="_blank" rel="noopener noreferrer"
            onClick={handleAppDownloadButtonClick}
            data-testid="download-link"
        >
            <div className="app-download-desktop-button-content">
                <SVGIcon inlineFlex markup={MOBILE__16}/><span/>
                <span className="app-download-desktop-button-text">{buttonLabel}</span>
            </div>
        </a>
    </div>);
};
